import { Box, Tab, Tabs, Typography } from '@mui/material';
import React from 'react'
import PropTypes from 'prop-types';
import QuizQuestions from '../components/quiz/QuizQuestions';
import QuizQuestionPappers from '../components/quiz/QuizQuestionPappers';
import QuizAnswers from '../components/quiz/QuizAnswers';
import BackButton from '../components/BackButton';

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function QuizPage() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <BackButton link={-1} />
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Answers" {...a11yProps(0)} />
                    <Tab label="Quiz" {...a11yProps(1)} />
                    <Tab label="Question" {...a11yProps(2)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <QuizAnswers />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <QuizQuestionPappers />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                <QuizQuestions />
            </CustomTabPanel>
        </Box>
    )
}

export default QuizPage